import React, { type ReactNode, useState } from 'react'
import GenericButton from '../../../components/GenericButton'
import { ButtonSize } from '../../../components/GenericButton/styles'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import { Chip } from '@mui/material'

interface UploadCsvButtonProps {
  value: string
  loadingDotCount: number
  setTaskIds: React.Dispatch<React.SetStateAction<Record<string, string>>>
  setUploadStatuses: React.Dispatch<React.SetStateAction<Record<string, ReactNode>>>
  setDescriptions: React.Dispatch<React.SetStateAction<Record<string, ReactNode>>>
  termId?: string
}

export const UploadCsvButton: React.FC<UploadCsvButtonProps> = ({
  value,
  setUploadStatuses,
  setTaskIds,
  setDescriptions,
  loadingDotCount,
  termId
}): JSX.Element => {
  const [isCsvModalOpen, setIsCsvModalOpen] = useState<boolean>(false)

  interface CsvConfig { title: string, csvHeaderEndPoint: string, uploadCsvEndpoint: string }
  const possibleCsvs: Record<string, CsvConfig> = {
    faculty: { title: 'Faculty', csvHeaderEndPoint: '/api/users/csv_headers', uploadCsvEndpoint: '/api/users/?is_faculty=True' },
    students: { title: 'Students', csvHeaderEndPoint: '/api/users/csv_headers', uploadCsvEndpoint: '/api/users/?is_student=True' },
    courses: { title: 'Courses', csvHeaderEndPoint: '/api/divisions/csv_headers', uploadCsvEndpoint: '/api/divisions/' },
    courseSections: { title: 'Course Sections', csvHeaderEndPoint: '/api/sections/csv_headers', uploadCsvEndpoint: `/api/sections/?term_id=${termId}` },
    instructorAssignments: { title: 'Instructor Assignments', csvHeaderEndPoint: '/api/users/roles/csv_headers?is_faculty=true', uploadCsvEndpoint: `/api/users/roles/?is_faculty=True&term_id=${termId}` },
    studentEnrollments: { title: 'Student Enrollments', csvHeaderEndPoint: '/api/users/roles/csv_headers?is_student=true', uploadCsvEndpoint: `/api/users/roles/?is_student=True&term_id=${termId}` }
  }

  const handleCloseModal = (): void => {
    setIsCsvModalOpen(false)
  }

  const handleUploadIsSuccessful = (): void => {
    setUploadStatuses((prevStatuses: Record<string, ReactNode>) => ({
      ...prevStatuses,
      [value]: <Chip label='Pending' color='warning' variant='outlined' size='small'/>
    }))
    setDescriptions((prevDescriptions: Record<string, ReactNode>) => ({
      ...prevDescriptions,
      [value]: `Pending${'.'.repeat(loadingDotCount)}`
    }))
  }

  const handleAddTaskId = (taskId: string): void => {
    setTaskIds((prev: Record<string, string>) => ({ ...prev, [value]: taskId }))
  }

  return (
    <>
      <GenericButton
          label='Upload'
          type='button'
          variant='contained'
          buttonSize={ButtonSize.Medium}
          onClick={() => { setIsCsvModalOpen(true) }}
      />
      <CsvMappingUpload
        isOpen={isCsvModalOpen}
        onClose={handleCloseModal}
        modalTitle={possibleCsvs[value].title}
        csvHeaderEndpoint={possibleCsvs[value].csvHeaderEndPoint}
        uploadCsvEndpoint= {possibleCsvs[value].uploadCsvEndpoint}
        onSuccess={handleUploadIsSuccessful}
        returnTaskId={handleAddTaskId}
      />
    </>
  )
}
